<template lang="pug">
  v-form.login-component.mt-3(
    ref="formLogin"
    @submit.prevent="submitLogin($event)"
  )
    v-container
      v-layout(
        row
        wrap
      )
        v-flex.py-0(
          xs12
        )
          h1 {{ $t('app.login.loginComponent.title') }}
        v-flex.py-2(
          xs12
        )
          span.subtitle {{ $t('app.login.loginComponent.subtitle') }}
        v-flex.py-0(
          xs12
        )
          alert-message(
            :error.sync="error"
            :message-default="$t('app.login.loginComponent.loginError')"
          )
        v-flex.py-0(
          xs12
        )
          input-text(
            required
            :label="$t('app.login.loginComponent.loginLabel')"
            v-model="payload.login"
            :maxlength="40"
          )
        v-flex.pt-0(
          xs12
        )
          input-password(
            required
            v-model="payload.senha"
          )
        v-flex.py-0(
          xs8
          mx-auto
        )
          btn-primary(
            block
            type="submit"
            :disabled="enableSubmit"
            :text="$t('app.login.loginComponent.enter')"
          )
          btn-flat(
            block
            @click="navigateTo('RecoverPassword')"
            :text="$t('app.login.loginComponent.forgotPassword')"
          )
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';
import InputPassword from 'Support/components/inputs/InputPassword.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import BtnFlat from 'Support/components/buttons/BtnFlat.vue';
import { login } from 'Support/services/login.service';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';
import AlertMessage from 'Support/components/alerts/AlertMessage.vue';

export default {
  name: 'Login',
  components: {
    BtnFlat,
    BtnPrimary,
    InputPassword,
    InputText,
    AlertMessage,
  },
  mixins: [PageableMixin],
  data() {
    return {
      payload: {
        login: '',
        senha: '',
      },
      error: {},
    };
  },
  computed: {
    enableSubmit() {
      return !this.payload.login
        || !this.payload.senha;
    },
  },
  methods: {
    submitLogin() {
      if (!this.$refs.formLogin.validate()) {
        return;
      }
      const loader = this.$loading.show();

      login(this.payload)
        .then(({ isFirstAccess }) => {
          if (isFirstAccess) {
            this.navigateTo('FirstAccess');
          } else {
            this.navigateTo('Contratacoes');
          }
          loader.hide();
        })
        .catch(({ response }) => {
          this.error = response.data;
          loader.hide();
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
  .login-component
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .subtitle
      font-style normal
      font-weight normal
      font-size 14px
      color #113752
</style>
